<template>
  <div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y bg-transparent">
      <div class="overflow-x-auto scrollbar-hidden bg-transparent">
        <div
          id="tabulator"
          ref="tableRef"
          class="table-report table-report--tabulator my-2 bg-transparent"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, getCurrentInstance } from 'vue'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import moment from 'moment-timezone'
import {
  cleanSession,
  getFirstErrorMessage,
  numberFormatter
} from '@/utils/tools'

export default defineComponent({
  props: {
    daterange: {
      type: String
    },
    orderSelectType: {
      type: String
    }
  },
  setup(props) {
    const tableRef = ref()
    const tabulator = ref()

    const getSvgByStatus = (status) => {
      switch (status) {
        case 'SENT':
          return `
            <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="25" rx="12.5" fill="#64748B"/>
            <g clip-path="url(#clip0_7271_15597)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9529 6.73529C12.2252 6.73529 11.5237 6.88969 10.8856 7.15681C10.2532 7.42151 9.67779 7.81215 9.19792 8.29202C8.72083 8.76911 8.33573 9.34517 8.06033 9.98529C7.789 10.6159 7.64119 11.3152 7.64119 12.0471C7.64119 12.7748 7.79559 13.4763 8.06271 14.1144C8.11821 14.247 8.12573 14.3948 8.08397 14.5324L7.04461 17.9554L10.4676 16.9161C10.6072 16.8737 10.7572 16.8821 10.8912 16.9397C11.5218 17.211 12.2211 17.3588 12.9529 17.3588C13.6807 17.3588 14.3822 17.2044 15.0203 16.9373C15.6527 16.6726 16.2281 16.2819 16.708 15.8021C17.1851 15.325 17.5702 14.7489 17.8456 14.1088C18.1169 13.4782 18.2647 12.7789 18.2647 12.0471C18.2647 11.3193 18.1103 10.6178 17.8432 9.97969C17.5785 9.34733 17.1878 8.77189 16.708 8.29202C16.2309 7.81493 15.6548 7.42982 15.0147 7.15443C14.3841 6.8831 13.6848 6.73529 12.9529 6.73529ZM10.4086 6.01732C11.1869 5.69149 12.0501 5.5 12.9529 5.5C13.8516 5.5 14.7171 5.68161 15.5029 6.0197C16.2793 6.35371 16.988 6.82505 17.5815 7.41854C18.1722 8.00926 18.6544 8.71858 18.9827 9.50269C19.3085 10.2811 19.5 11.1442 19.5 12.0471C19.5 12.9458 19.3184 13.8112 18.9803 14.597C18.6463 15.3734 18.1749 16.082 17.5815 16.6755C16.9908 17.2662 16.2815 17.7486 15.4973 18.0768C14.719 18.4026 13.8558 18.5941 12.9529 18.5941C12.135 18.5941 11.3446 18.4437 10.6167 18.1618L6.29711 19.4733C6.07898 19.5396 5.84211 19.4803 5.68092 19.3191C5.51973 19.1579 5.46043 18.921 5.52666 18.7029L6.83907 14.3806C6.56468 13.6584 6.4059 12.8692 6.4059 12.0471C6.4059 11.1484 6.58752 10.2829 6.9256 9.49709C7.25961 8.72074 7.73094 8.01203 8.32444 7.41854C8.91516 6.82782 9.62445 6.34556 10.4086 6.01732Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_7271_15597">
            <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            Solicitada
          `
        case 'IN PROCESS':
          return `
            <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="25" rx="12.5" fill="#EF5DA8"/>
            <g clip-path="url(#clip0_7271_15593)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1546 12.5C10.1546 13.7935 11.2065 14.8454 12.5 14.8454C13.7934 14.8454 14.8453 13.7935 14.8453 12.5C14.8453 11.2066 13.7934 10.1547 12.5 10.1547C11.2065 10.1547 10.1546 11.2066 10.1546 12.5ZM11.3545 12.5008C11.3545 11.8689 11.868 11.3554 12.5 11.3554C13.1311 11.3554 13.6454 11.8689 13.6454 12.5008C13.6454 13.1328 13.1319 13.6463 12.5 13.6463C11.868 13.6463 11.3545 13.1328 11.3545 12.5008Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7826 17.7106C10.7826 18.6977 11.5737 19.5 12.5464 19.5C13.5023 19.5 14.3102 18.6689 14.311 17.689C14.3118 17.5314 14.4094 17.361 14.5358 17.3074C14.6598 17.2531 14.8453 17.2947 14.9517 17.3986C15.646 18.0922 16.7707 18.0954 17.4586 17.4082C17.793 17.0739 17.973 16.6243 17.9658 16.1436C17.9594 15.6716 17.7722 15.2293 17.445 14.9021C17.3378 14.7925 17.2995 14.6142 17.3554 14.4878C17.3562 14.4854 17.357 14.4838 17.3578 14.4814C17.4106 14.3582 17.5634 14.2646 17.7106 14.2638C18.6977 14.2638 19.5 13.4727 19.5 12.5C19.5 11.5441 18.6697 10.7362 17.689 10.7362C17.5418 10.7354 17.365 10.6218 17.3075 10.4882C17.2507 10.3618 17.2963 10.1539 17.3986 10.0491C18.0922 9.35396 18.0962 8.22929 17.4082 7.54217C17.0739 7.2078 16.6395 7.02782 16.1436 7.03502C15.6716 7.04142 15.2293 7.2286 14.9021 7.55576C14.7925 7.66215 14.6142 7.70055 14.4814 7.64215C14.3582 7.58936 14.2646 7.43658 14.2638 7.2894C14.2638 6.30231 13.4727 5.5 12.5 5.5C11.5441 5.5 10.7362 6.33031 10.7362 7.31099C10.7354 7.45818 10.6218 7.63496 10.4882 7.69255C10.3626 7.75014 10.1539 7.70375 10.0491 7.60136C9.35396 6.90704 8.22929 6.90384 7.54217 7.59176C7.20781 7.92612 7.02783 8.37567 7.03503 8.85642C7.04142 9.32836 7.2286 9.77071 7.55577 10.0979C7.66295 10.2067 7.70135 10.385 7.63096 10.5474C7.58296 10.6778 7.43018 10.7794 7.2894 10.7826C6.30231 10.7826 5.5 11.5737 5.5 12.5464C5.5 13.5023 6.33031 14.3102 7.31099 14.3102C7.46858 14.311 7.63896 14.4086 7.69255 14.535C7.74774 14.6598 7.70535 14.8437 7.60136 14.9509C6.90784 15.646 6.90384 16.7707 7.59176 17.4578C7.92612 17.7922 8.36367 17.9594 8.85642 17.965C9.32836 17.9586 9.77071 17.7714 10.0979 17.4442C10.2067 17.3378 10.3858 17.3003 10.5474 17.369C10.6778 17.417 10.7794 17.5698 10.7826 17.7106ZM10.997 16.2572C10.801 16.1708 10.5922 16.1284 10.3826 16.1284C9.97309 16.1284 9.56274 16.2884 9.25317 16.5907C9.0276 16.8155 8.65404 16.8243 8.43806 16.6075C8.22209 16.3924 8.22689 16.0212 8.45406 15.794C8.91001 15.3277 9.0444 14.627 8.79242 14.0558C8.55085 13.4935 7.95812 13.1127 7.31339 13.1103C6.98623 13.1103 6.69986 12.8464 6.69986 12.5464C6.69986 12.2408 6.96943 11.9825 7.303 11.9825C7.95412 11.9673 8.53805 11.5569 8.74283 10.997C8.998 10.4194 8.86602 9.72032 8.40927 9.25317C8.18369 9.0276 8.1757 8.65484 8.39247 8.43806C8.60765 8.22209 8.978 8.22769 9.20598 8.45406C9.66832 8.90681 10.3962 9.04439 10.9674 8.79242C11.5353 8.54845 11.9337 7.94212 11.9361 7.31339C11.9361 6.98623 12.2 6.69986 12.5 6.69986C12.8056 6.69986 13.0639 6.96943 13.0639 7.2918C13.0671 7.91972 13.4463 8.50446 14.003 8.74283C14.5814 8.9988 15.2797 8.86522 15.7468 8.40927C15.9724 8.18449 16.3452 8.17649 16.5619 8.39247C16.7779 8.60764 16.7731 8.9788 16.5459 9.20598C16.0932 9.66912 15.9556 10.3962 16.2076 10.9674C16.4515 11.5353 17.0579 11.9337 17.6866 11.9361C18.0138 11.9361 18.3001 12.2 18.3001 12.5C18.3001 12.8056 18.0306 13.0639 17.7082 13.0639C17.0811 13.0671 16.4987 13.4447 16.2564 14.0054C16.002 14.5822 16.1348 15.2805 16.5907 15.7468C16.8163 15.9724 16.8243 16.3452 16.6075 16.5619C16.3924 16.7787 16.022 16.7723 15.794 16.5459C15.3277 16.0908 14.627 15.9556 14.0558 16.2076C13.4935 16.4491 13.1127 17.0419 13.1103 17.6866C13.1103 18.0138 12.8464 18.3001 12.5464 18.3001C12.2408 18.3001 11.9825 18.0306 11.9825 17.697C11.9673 17.0459 11.5569 16.4619 10.997 16.2572Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_7271_15593">
            <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            En proceso
          `
        case 'ACCEPTED':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#3B82F6"/>
              <g clip-path="url(#clip0_7271_15588)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3243 7.67574C19.5586 7.91005 19.5586 8.28995 19.3243 8.52426L10.5243 17.3243C10.2899 17.5586 9.91005 17.5586 9.67574 17.3243L5.67574 13.3243C5.44142 13.0899 5.44142 12.7101 5.67574 12.4757C5.91005 12.2414 6.28995 12.2414 6.52426 12.4757L10.1 16.0515L18.4757 7.67574C18.71 7.44142 19.0899 7.44142 19.3243 7.67574Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15588">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Aceptada
            `
        case 'COUNTERPROPOSAL':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#F97316"/>
              <g clip-path="url(#clip0_7271_15580)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9235 6.52426C13.1578 6.28995 13.1578 5.91005 12.9235 5.67574C12.6892 5.44142 12.3093 5.44142 12.075 5.67574L9.67495 8.07574C9.44064 8.31005 9.44064 8.68995 9.67495 8.92426L12.075 11.3243C12.3093 11.5586 12.6892 11.5586 12.9235 11.3243C13.1578 11.0899 13.1578 10.7101 12.9235 10.4757L11.5477 9.1H12.4992C15.0398 9.1 17.0992 11.1594 17.0992 13.7C17.0992 16.2406 15.0398 18.3 12.4992 18.3C9.95859 18.3 7.89922 16.2406 7.89922 13.7C7.89922 13.3686 7.63059 13.1 7.29922 13.1C6.96785 13.1 6.69922 13.3686 6.69922 13.7C6.69922 16.9034 9.29585 19.5 12.4992 19.5C15.7026 19.5 18.2992 16.9034 18.2992 13.7C18.2992 10.4966 15.7026 7.9 12.4992 7.9H11.5477L12.9235 6.52426Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15580">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Contrapropuesta
            `
        case 'WON':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="25" height="25" rx="12.5" fill="#16A34A"/>
              <g clip-path="url(#clip0_7271_15615)">
              <path d="M18.4396 6.46073C18.2764 6.34792 18.0683 6.32391 17.8827 6.39752C16.9626 6.75677 15.3816 7.26404 14.9015 7.21283C14.4543 7.16242 13.7462 6.79277 13.0605 6.43433C12.2004 5.98467 11.3867 5.56062 10.681 5.50461C9.65366 5.4326 7.19174 6.2255 6.70848 6.38792C6.46365 6.47033 6.29883 6.69916 6.29883 6.9568V8.66261V13.7817V18.8999C6.29883 19.2312 6.56766 19.5 6.8989 19.5C7.23015 19.5 7.49898 19.2312 7.49898 18.8999V14.2177C8.55272 13.8849 10.0545 13.4784 10.585 13.5272C11.0474 13.5632 11.8211 13.9681 12.5036 14.3241C13.3221 14.7514 14.0958 15.1554 14.7655 15.2315C14.8215 15.2379 14.8823 15.2411 14.9479 15.2411C15.9649 15.2411 17.9163 14.4986 18.3188 14.3409C18.5484 14.2513 18.7004 14.0289 18.7004 13.7825V6.9576C18.702 6.75757 18.6044 6.57275 18.4396 6.46073ZM17.5019 13.3664C16.5633 13.7097 15.3288 14.0777 14.9023 14.0385C14.4551 13.9881 13.747 13.6184 13.0613 13.26C12.2012 12.8103 11.3875 12.3855 10.6818 12.3295C10.6322 12.3255 10.5786 12.3239 10.5226 12.3239C9.74247 12.3239 8.38869 12.6911 7.50058 12.9608V8.66181V7.39205C8.55192 7.06081 10.0577 6.64876 10.5866 6.70156C11.049 6.73757 11.8227 7.14242 12.5052 7.49846C13.3237 7.92572 14.0974 8.32897 14.7671 8.40498C15.4128 8.48019 16.653 8.10814 17.5011 7.81611V13.3664H17.5019Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15615">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Cotización aceptada
            `
        case 'LOSS':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#CE0100"/>
              <g clip-path="url(#clip0_7271_15607)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 6.66667C9.27834 6.66667 6.66667 9.27834 6.66667 12.5C6.66667 15.7217 9.27834 18.3333 12.5 18.3333C15.7217 18.3333 18.3333 15.7217 18.3333 12.5C18.3333 9.27834 15.7217 6.66667 12.5 6.66667ZM5.5 12.5C5.5 8.63401 8.63401 5.5 12.5 5.5C16.366 5.5 19.5 8.63401 19.5 12.5C19.5 16.366 16.366 19.5 12.5 19.5C8.63401 19.5 5.5 16.366 5.5 12.5ZM15.2458 9.75419C15.4736 9.98199 15.4736 10.3513 15.2458 10.5791L13.325 12.5L15.2458 14.4209C15.4736 14.6487 15.4736 15.018 15.2458 15.2458C15.018 15.4736 14.6487 15.4736 14.4209 15.2458L12.5 13.325L10.5791 15.2458C10.3513 15.4736 9.98199 15.4736 9.75419 15.2458C9.52638 15.018 9.52638 14.6487 9.75419 14.4209L11.675 12.5L9.75419 10.5791C9.52638 10.3513 9.52638 9.98199 9.75419 9.75419C9.98199 9.52638 10.3513 9.52638 10.5791 9.75419L12.5 11.675L14.4209 9.75419C14.6487 9.52638 15.018 9.52638 15.2458 9.75419Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15607">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Rechazada
            `
        case 'REQUOTING':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#A855F7"/>
              <g clip-path="url(#clip0_7271_15611)">
              <path d="M9.47132 17.6073H8.33618C7.81478 17.6073 7.39024 17.1828 7.39024 16.6614V7.58032C7.39024 7.05891 7.81478 6.63437 8.33618 6.63437H11.174V10.229C11.174 10.5423 11.4283 10.7965 11.7416 10.7965H15.374C15.4527 11.016 15.657 11.1749 15.9038 11.1749C16.217 11.1749 16.4713 10.9206 16.4713 10.6073V10.229C16.4713 10.1533 16.4562 10.0791 16.4274 10.0103C16.3987 9.94141 16.357 9.87935 16.3056 9.82789L12.1434 5.66573C12.0912 5.61351 12.0299 5.57265 11.961 5.54389C11.8922 5.51513 11.818 5.5 11.7423 5.5H8.33694C7.18894 5.5 6.25586 6.43308 6.25586 7.58108V16.6622C6.25586 17.8102 7.18894 18.7432 8.33694 18.7432H9.47208C9.78537 18.7432 10.0396 18.489 10.0396 18.1757C10.0396 17.8624 9.78462 17.6073 9.47132 17.6073ZM12.3092 7.43654L14.5333 9.66065H12.3092V7.43654ZM18.2595 12.0255C17.9697 11.7357 17.5505 11.5639 17.11 11.5541C16.656 11.5283 16.2284 11.7062 15.9348 11.9998L11.0961 16.8461C11.0007 16.9414 10.9425 17.0678 10.9311 17.2025L10.7956 18.887C10.782 19.0535 10.8433 19.2185 10.9629 19.3358C11.0696 19.4417 11.2134 19.5 11.3617 19.5C11.3783 19.5 11.3958 19.4992 11.4132 19.4977L13.1143 19.3426C13.2468 19.3297 13.3701 19.2722 13.464 19.1784L18.3027 14.3329C18.9066 13.7305 18.8854 12.6521 18.2595 12.0255ZM17.5013 13.5292L12.8079 18.2294L11.983 18.3051L12.0473 17.5014L16.7385 12.8027C16.8126 12.7285 16.9481 12.693 17.0843 12.6892C17.2334 12.693 17.3726 12.7444 17.4559 12.8292C17.6345 13.0055 17.6579 13.3725 17.5013 13.5292Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15611">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Recotizada
            `
        case 'CLOSE':
          return `
              <svg
                  class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12.5" cy="12.5" r="12.5" fill="#27AE60"/>
                  <path d="M11.2313 15.1282L8.53904 12.4359L7.6416 13.3334L11.2313 16.9231L18.9237 9.23081L18.0262 8.33337L11.2313 15.1282Z" fill="white"/>
              </svg>
              Finalizado
            `
      }
    }

    const initTabulator = () => {
      const internalInstance = getCurrentInstance()
      const that = internalInstance.appContext.config.globalProperties
      const ajaxURL = `${process.env.VUE_APP_BASE_API_URL}/sales-operator/quotations/all-my-quotations-created`
      const ajaxConfig = {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${that.$store.state.auth.token}`
        }
      }
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxSorting: false,
        ajaxFiltering: false,
        pagination: 'remote',
        paginationSize: 10,
        ajaxURL,
        ajaxConfig,
        ajaxRequesting: (_url, params) => {
          if (props.daterange) {
            const dates = props.daterange.split(' - ')
            params.date_start = moment(dates[0], 'DD-MM-YYYY')
              .tz('America/Mexico_City')
              .format('YYYY-MM-DD')
            params.date_end = moment(dates[1], 'DD-MM-YYYY')
              .tz('America/Mexico_City')
              .format('YYYY-MM-DD')
          }
          if (props.orderSelectType) {
            params.order_select_type = props.orderSelectType
          }
          that.$store.commit('main/setShowSpinner', true)
        },
        ajaxError: (_error) => {
          const error = { response: _error }
          if (error.response.status === 401) {
            that.$toast.error('Su sesión ha expirado', {
              position: 'top'
            })
            return cleanSession(that.$store, that.$router)
          }
          that.$toast.error(getFirstErrorMessage(error), {
            position: 'top'
          })
          that.$store.commit('main/setShowSpinner', false)
        },
        dataLoaded: (_data) => that.$store.commit('main/setShowSpinner', false),
        printAsHtml: false,
        printStyled: false,
        paginationSizeSelector: false,
        responsiveLayout: 'collapse',
        layout: 'fitColumns',
        placeholder: '',
        rowClick: (_e, row) => {
          if (
            _e.target.closest('.tabulator-responsive-collapse-toggle') ||
            _e.target.closest('.tabulator-col-content')
          ) {
            return
          }
          that.$router.push({
            name: 'quotation',
            params: { id: row.getData().id }
          })
        },
        columns: [
          {
            formatter: 'responsiveCollapse',
            width: 30,
            minWidth: 20,
            hozAlign: 'center',
            resizable: false,
            headerSort: false
          },
          {
            title: ' ',
            minWidth: 50,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div class="flex lg:justify-center">
                  <div class="intro-x w-10 h-10 image-fit">
                      <img
                        tag="img"
                        alt="imagen del producto"
                        style="box-shadow: 0 0 0 !important"
                        src="${
                          cell.getData().product?.image?.length
                            ? cell.getData().product?.image[0]
                            : require(cell.getData().product.sku !==
                                'COTESPI001'
                                ? '@/assets/images/product.svg'
                                : '@/assets/images/COTESPI001.svg')
                        }"
                        crossorigin="anonymous"
                      />
                  </div>
              </div>`
            }
          },
          {
            title: 'Nombre',
            minWidth: 150,
            responsive: 0,
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div>
                <div class="font-medium whitespace-nowrap font-poppins">${
                  cell.getData()?.product?.name || '-'
                }</div>
                <div class="text-gray-600 text-xs whitespace-nowrap">${
                  cell
                    .getData()
                    .product?.categories?.map(({ name }) => name)
                    .join(', ') || '-'
                }</div>
                  </div>
              </div>`
            }
          },
          {
            title: 'No. de solicitud',
            minWidth: 80,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().id
                }</div>
              </div>`
            }
          },
          {
            title: 'No. de piezas',
            minWidth: 80,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `
              <div>
                <div class="font-medium whitespace-nowrap">
                    ${
                      cell.getData().historic_prices[0]
                        ? numberFormatter.format(
                            cell.getData().historic_prices[0].units || 0
                          )
                        : '0'
                    }
                  </div>
              </div>
              `
            }
          },
          {
            title: 'Fecha de solicitud',
            minWidth: 90,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div>
                <div class="font-medium whitespace-nowrap">${moment(
                  cell.getData().created_at
                )
                  .tz('America/Mexico_City')
                  .format('DD/MM/YYYY')}</div>
              </div>`
            }
          },
          {
            title: 'Cliente',
            minWidth: 100,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div>
                <div class="truncate max-w-[100px]">${
                  cell.getData().brand?.client?.name ||
                  (cell.getData()?.sales_operator
                    ? cell.getData()?.sales_operator?.name +
                      ' ' +
                      cell.getData()?.sales_operator?.last_name
                    : '-') ||
                  '-'
                }</div>
              </div>`
            }
          },
          {
            title: 'Responsable',
            minWidth: 200,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div>
                <div class="whitespace-nowrap">${
                  cell.getData().admin
                    ? cell.getData().admin?.name +
                      ' ' +
                      cell.getData().admin?.last_name
                    : '-'
                }</div>
              </div>`
            }
          },
          {
            title: 'Estatus',
            minWidth: 300,
            field: 'actions',
            responsive: 1,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `
              <div class="flex lg:justify-center items-center gap-2 w-full max-w-[200px]">
                <a class="flex items-center flex-1" href="javascript:;">
                      ${getSvgByStatus(cell.getData().status)}
                </a>
                <button class="text-white rounded-full w-10 h-10" style="background: linear-gradient(87.96deg, #e85c04 0%, #faa306 99.62%);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right" data-v-6e03bdf7=""><polyline points="9 18 15 12 9 6"></polyline></svg>
                </button>
              </div>`
            }
          }
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    // Redraw table onresize
    const reInitOnResizeWindow = () => {
      window.addEventListener('resizeTabulatorDetailedQuotations', () => {
        tabulator.value.redraw()
        feather.replace({
          'stroke-width': 1.5
        })
      })
    }

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
    })

    return {
      tableRef,
      tabulator
    }
  },
  async unmounted() {
    window.removeEventListener('resizeTabulatorDetailedQuotations', () => {
      return true
    })
  },
  watch: {
    daterange() {
      if (this.tabulator) {
        this.tabulator.setPage(1)
      }
    },
    orderSelectType() {
      if (this.tabulator) {
        this.tabulator.setPage(1)
      }
    }
  }
})
</script>
<style scoped>
.tabulator-row {
  margin: 12px 0;
}
.tabulator-headers {
  background: black !important;
  color: white !important;
}
.tabulator .tabulator-tableHolder .tabulator-table {
  background: transparent !important;
}
.tabulator-tableHolder {
  background: transparent !important;
}
</style>
